import React from 'react';
import { StoreInfo, NavItem, Category, ServiceDetail } from './types';
import { BookOpen, Gamepad2, Disc, MonitorPlay, Sparkles, Wrench, Layers } from 'lucide-react';

export const STORE_INFO: StoreInfo = {
  name: "Borden's BookShoppe",
  address: "114 W Broadway, Astoria, IL, 61501",
  phone: "209-968-2435",
  email: "Bordensbookshoppellc@gmail.com",
  hours: {
    weekdays: "9:00 AM - 5:00 PM",
    weekend: "Sat: 8:00 AM - 1:00 PM\nSun: Closed",
  }
};

export interface ServedCity {
  id: string;
  name: string;
  time: string;
  distance: string;
  description: string;
}

export const SERVED_CITIES: ServedCity[] = [
  { id: 'peoria', name: 'Peoria', time: '1h 15m', distance: '60 miles', description: 'The premier destination for Peoria residents looking for rare books and expert console repair.' },
  { id: 'springfield', name: 'Springfield', time: '1h 15m', distance: '65 miles', description: 'Just a short trip from the State Capital for the best selection of used video games and movies.' },
  { id: 'quincy', name: 'Quincy', time: '1h 25m', distance: '75 miles', description: 'Serving the Gem City with professional disc resurfacing and a massive used book collection.' },
  { id: 'macomb', name: 'Macomb', time: '35 mins', distance: '28 miles', description: 'The closest hub for Western Illinois University students to trade in games and find textbooks.' },
  { id: 'galesburg', name: 'Galesburg', time: '1h 10m', distance: '55 miles', description: 'A favorite stop for Galesburg collectors hunting for vintage Nintendo and PlayStation gear.' },
  { id: 'canton', name: 'Canton', time: '30 mins', distance: '22 miles', description: 'Providing Canton families with affordable used books and tech support for all game consoles.' },
  { id: 'pekin', name: 'Pekin', time: '55 mins', distance: '48 miles', description: 'Pekin residents trust us for high-quality disc repair and a rotating stock of classic cinema.' },
  { id: 'jacksonville', name: 'Jacksonville', time: '50 mins', distance: '45 miles', description: 'Worth the drive from Jacksonville for our unique "staff pick" recommendations and rare finds.' },
  { id: 'lincoln', name: 'Lincoln', time: '1 hour', distance: '52 miles', description: 'Lincoln collectors come to Borden\'s for our pristine condition used games and first-edition books.' },
  { id: 'havana', name: 'Havana', time: '20 mins', distance: '15 miles', description: 'Your neighborhood sanctuary for physical media right across the river from Havana.' },
  { id: 'rushville', name: 'Rushville', time: '20 mins', distance: '18 miles', description: 'Serving the Rushville community with a massive selection of paperbacks and hardcovers.' },
  { id: 'beardstown', name: 'Beardstown', time: '30 mins', distance: '24 miles', description: 'Quick and easy access for Beardstown residents to get their consoles cleaned and repaired.' },
  { id: 'monmouth', name: 'Monmouth', time: '1h 15m', distance: '62 miles', description: 'The regional destination for Monmouth media lovers who value physical collections.' },
  { id: 'morton', name: 'Morton', time: '1 hour', distance: '55 miles', description: 'From the Pumpkin Capital to the Book Shoppe, we offer a selection Morton stores can\'t match.' }
];

export const NAV_ITEMS: NavItem[] = [
  { label: "Home", href: "home" },
  { label: "About", href: "about" },
  { label: "Donations", href: "donations" },
  { label: "Services", href: "services" },
  { label: "Gallery", href: "gallery" },
  { label: "News", href: "news" },
  { label: "Shop", href: "shop" },
  { label: "Visit Us", href: "visit" },
];

export const CATEGORIES: Category[] = [
  {
    id: 'books',
    title: 'Used Books',
    description: 'From timeless classics to contemporary thrillers. Hardcovers, paperbacks, and rare first editions lining our rustic shelves.',
    icon: <BookOpen className="w-6 h-6" />,
    image: '/images/category-books.jpg'
  },
  {
    id: 'games',
    title: 'Games & Consoles',
    description: 'We buy and sell Games, Consoles, and Accessories! NES, SNES, N64, PlayStation, Xbox, and more.',
    icon: <Gamepad2 className="w-6 h-6" />,
    image: '/images/category-games.jpg'
  },
  {
    id: 'collectibles',
    title: 'Collectibles & Comics',
    description: 'Vintage toys, action figures, TCG cards, and graphic novels. The ultimate treasure hunt for collectors.',
    icon: <Sparkles className="w-6 h-6" />,
    image: '/images/category-collectibles.jpg'
  },
  {
    id: 'movies',
    title: 'DVDs & Blu-rays',
    description: 'Physical media is forever. Browse our extensive library of films and TV series.',
    icon: <MonitorPlay className="w-6 h-6" />,
    image: '/images/category-movies.jpg'
  },
  {
    id: 'music',
    title: 'CDs & Audio',
    description: 'Rediscover the album experience. Rock, Jazz, Pop, and Classical available on CD.',
    icon: <Disc className="w-6 h-6" />,
    image: '/images/category-music.jpg'
  }
];

export const SERVICES: ServiceDetail[] = [
  {
    id: 'resurfacing',
    title: 'Professional Disc Resurfacing',
    description: 'Using high-grade industrial machinery, we can remove scratches from game discs, DVDs, and CDs, bringing your unreadable media back to life.',
    priceInfo: 'Starting at $2.50 per disc. Bulk discounts available.',
    icon: <Layers className="w-8 h-8" />
  },
  {
    id: 'repair',
    title: 'Console Repair & Cleaning',
    description: 'Experiencing the Red Ring of Death or a sticky disc drive? We offer expert repair for Nintendo, PlayStation, Xbox, and Retro consoles.',
    priceInfo: 'Estimates provided in-store.',
    icon: <Wrench className="w-8 h-8" />
  }
];